import React from 'react';

/**
 * Semicircular sentiment gauge (pure SVG). Ported from
 * D:\campaigning-system\src\components\charts\Gauge.tsx (cos-* tokens; types stripped).
 */
export function Gauge({ value, label, size = 200, breakdown }) {
  const clamped = Math.max(0, Math.min(100, value));
  const r = size / 2 - 14;
  const cx = size / 2;
  const cy = size / 2 + 4;
  const circ = Math.PI * r; // half circle
  const offset = circ * (1 - clamped / 100);

  return (
    <div className="flex flex-col items-center">
      <div className="relative" style={{ width: size, height: size / 2 + 20 }}>
        <svg width={size} height={size / 2 + 20} viewBox={`0 0 ${size} ${size / 2 + 20}`}>
          <defs>
            <linearGradient id="cos-gauge-grad" x1="0" y1="0" x2="1" y2="0">
              <stop offset="0%" stopColor="#B0872F" />
              <stop offset="45%" stopColor="#38BEB0" />
              <stop offset="100%" stopColor="#087F78" />
            </linearGradient>
          </defs>
          <path
            d={`M ${cx - r} ${cy} A ${r} ${r} 0 0 1 ${cx + r} ${cy}`}
            fill="none"
            stroke="rgba(70,80,72,0.10)"
            strokeWidth={12}
            strokeLinecap="round"
          />
          <path
            d={`M ${cx - r} ${cy} A ${r} ${r} 0 0 1 ${cx + r} ${cy}`}
            fill="none"
            stroke="url(#cos-gauge-grad)"
            strokeWidth={12}
            strokeLinecap="round"
            strokeDasharray={circ}
            strokeDashoffset={offset}
            style={{ transition: 'stroke-dashoffset 0.8s cubic-bezier(0.16,1,0.3,1)' }}
          />
        </svg>
        <div className="absolute inset-x-0 bottom-0 flex flex-col items-center">
          <span className="mono text-3xl font-bold leading-none text-cos-ink">{clamped}</span>
          {label && <span className="mt-1 text-2xs font-medium uppercase tracking-wide text-cos-ink-muted">{label}</span>}
        </div>
      </div>

      {breakdown && (
        <div className="mt-3 flex w-full items-center justify-between gap-2 text-2xs">
          <span className="flex items-center gap-1.5 text-cos-ink-secondary">
            <span className="h-2 w-2 rounded-full bg-cos-teal-deep" /> Positive
            <span className="mono font-semibold text-cos-ink">{breakdown.positive}%</span>
          </span>
          <span className="flex items-center gap-1.5 text-cos-ink-secondary">
            <span className="h-2 w-2 rounded-full bg-cos-beige-dark" /> Neutral
            <span className="mono font-semibold text-cos-ink">{breakdown.neutral}%</span>
          </span>
          <span className="flex items-center gap-1.5 text-cos-ink-secondary">
            <span className="h-2 w-2 rounded-full bg-cos-status-coral" /> Negative
            <span className="mono font-semibold text-cos-ink">{breakdown.negative}%</span>
          </span>
        </div>
      )}
    </div>
  );
}

export default Gauge;
